import React from 'react';
import { Navigate } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

const PrivateRoute = ({ children }: Props) => {
  const token = localStorage.getItem('token');
  const fullname = localStorage.getItem('fullname');

  if (!token || !fullname) {
    return <Navigate to="/ingreso" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
